/* tslint:disable */
/* eslint-disable */
/**
 * Commerce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';
import type { ProductModel } from './ProductModel';
import {
    ProductModelFromJSON,
    ProductModelFromJSONTyped,
    ProductModelToJSON,
} from './ProductModel';

/**
 * 
 * @export
 * @interface CustomizerModel
 */
export interface CustomizerModel {
    /**
     * 
     * @type {Price}
     * @memberof CustomizerModel
     */
    total?: Price;
    /**
     * 
     * @type {ProductModel}
     * @memberof CustomizerModel
     */
    product?: ProductModel;
    /**
     * 
     * @type {any}
     * @memberof CustomizerModel
     */
    content?: any;
}

/**
 * Check if a given object implements the CustomizerModel interface.
 */
export function instanceOfCustomizerModel(value: object): boolean {
    return true;
}

export function CustomizerModelFromJSON(json: any): CustomizerModel {
    return CustomizerModelFromJSONTyped(json, false);
}

export function CustomizerModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomizerModel {
    if (json == null) {
        return json;
    }
    return {
        
        'total': json['total'] == null ? undefined : PriceFromJSON(json['total']),
        'product': json['product'] == null ? undefined : ProductModelFromJSON(json['product']),
        'content': json['content'] == null ? undefined : json['content'],
    };
}

export function CustomizerModelToJSON(value?: CustomizerModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'total': PriceToJSON(value['total']),
        'product': ProductModelToJSON(value['product']),
        'content': value['content'],
    };
}

